import Component from '@glimmer/component';
export default class UploaderFileProgressComponent extends Component {
  get progress() {
    return Math.round(this.args.progress);
  }
  get asLink() {
    return this.args.asLink ?? true;
  }
}